import React from 'react';
import { copyFor } from '../../copy/copy';
import PropTypes from 'prop-types';

const TwitterIcon = props => (
    <svg width="24" height="20" viewBox={props.viewBox||"0 0 24 20"} xmlns="http://www.w3.org/2000/svg"
    >
        <title>{copyFor('icons', 'twitter')}</title>
        <path
            d="M24 2.368c-.883.402-1.832.672-2.828.794C22.19 2.538 22.97 1.548 23.337.37c-.95.577-2.005.998-3.127 1.225C19.313.613 18.032 0 16.616 0c-3.18 0-5.515 3.04-4.797 6.2C7.727 5.99 4.1 3.98 1.67.923c-1.29 2.27-.668 5.238 1.524 6.74-.806-.026-1.566-.252-2.23-.63-.053 2.338 1.582 4.527 3.95 5.014-.693.193-1.452.238-2.224.086.626 2.006 2.444 3.465 4.6 3.506-2.07 1.664-4.678 2.408-7.29 2.092C2.18 19.164 4.768 20 7.548 20c9.142 0 14.307-7.917 13.995-15.018C22.505 4.27 23.34 3.38 24 2.368z"
            fillRule="nonzero"
            fill="#1DA1F2"
        />
    </svg>
);

TwitterIcon.propTypes={
	width:PropTypes.number,
	height:PropTypes.number,
	viewBox:PropTypes.string,
}

export default TwitterIcon;
